import React from "react";

const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://sridhardental.com/#organization",
        "name": "Dr. Sridhar International Dental Hospitals & Research Center",
        "alternateName": "Sridhar Dental",
        "url": "https://sridhardental.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://sridhardental.com/logo.png"
        },
        "image": "https://sridhardental.com/logo.png",
        "description":
          "Dr. Sridhar International Dental Hospitals & Research Center provides advanced dental treatments including dental implants, smile designing, orthodontics, root canal treatment, laser dentistry, pediatric dentistry, oral surgery, and cosmetic dentistry in Vijayawada and Hyderabad.",
        "telephone": "+91-9490948081",
        "email": "dr.sridhardental@gmail.com",
        "founder": {
          "@type": "Person",
          "name": "Dr. Arumalla Sridhar Reddy"
        },
        "sameAs": [
          "https://www.facebook.com/",
          "https://www.instagram.com/",
          "https://www.youtube.com/",
          "https://www.linkedin.com/"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-9490948081",
          "contactType": "Customer Support",
          "availableLanguage": [
            "English",
            "Telugu",
            "Hindi"
          ]
        },
        "areaServed": [
          "Vijayawada",
          "Hyderabad",
          "Andhra Pradesh",
          "Telangana"
        ]
      },
      {
        "@type": "Dentist",
        "@id": "https://sridhardental.com/#dentist",
        "name": "Dr. Sridhar International Dental Hospitals & Research Center",
        "url": "https://sridhardental.com/",
        "telephone": "+91-9490948081",
        "email": "dr.sridhardental@gmail.com",
        "priceRange": "₹₹",
        "medicalSpecialty": [
          "Dental Implants",
          "Cosmetic Dentistry",
          "Orthodontics",
          "Root Canal Treatment",
          "Laser Dentistry",
          "Pediatric Dentistry",
          "Oral Surgery",
          "Periodontics"
        ],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Vijaya Talkies Centre, Eluru Road, Governorpet",
          "addressLocality": "Vijayawada",
          "addressRegion": "Andhra Pradesh",
          "postalCode": "520002",
          "addressCountry": "IN"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "opens": "10:00",
            "closes": "20:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Sunday",
            "opens": "10:00",
            "closes": "13:00"
          }
        ],
        "parentOrganization": {
          "@id": "https://sridhardental.com/#organization"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://sridhardental.com/#website",
        "url": "https://sridhardental.com/",
        "name": "Dr. Sridhar International Dental Hospitals",
        "publisher": {
          "@id": "https://sridhardental.com/#organization"
        },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://sridhardental.com/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://sridhardental.com/#webpage",
        "url": "https://sridhardental.com/",
        "name": "Best Dental Hospital in Vijayawada & Hyderabad",
        "description":
          "Advanced dental care, dental implants, smile designing, root canal treatment, orthodontics, cosmetic dentistry, and laser dentistry.",
        "isPartOf": {
          "@id": "https://sridhardental.com/#website"
        },
        "about": {
          "@id": "https://sridhardental.com/#organization"
        },
        "inLanguage": "en-IN"
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
};

export default SchemaMarkup;